import { AnyAction } from 'redux'

import { UserConfig } from '@/types'
import {
  SET_LOCALE,
  SET_PROGRESS,
  SET_MEMBERSHIP_CODE,
  SET_CONSUMER_NETWORK_UUID,
  SET_COOKIE_PREFERENCE,
  SET_PARTNER_SLUG,
  RESET_USER_CONFIG,
} from './constants'

const initialState: UserConfig = {
  locale: '',
  signupProgress: 0,
  membershipCode: '',
  consumerNetworkUuid: '',
  cookiePreference: null,
}

export default (state = { ...initialState }, { type, payload }: AnyAction) => {
  switch (type) {
    case SET_LOCALE:
      return {
        ...state,
        locale: payload,
      }
    case SET_PROGRESS:
      return {
        ...state,
        signupProgress: payload,
      }
    case SET_MEMBERSHIP_CODE:
      return {
        ...state,
        membershipCode: payload,
      }
    case SET_CONSUMER_NETWORK_UUID:
      return {
        ...state,
        consumerNetworkUuid: payload,
      }
    case SET_COOKIE_PREFERENCE:
      return {
        ...state,
        cookiePreference: payload,
      }
    case SET_PARTNER_SLUG:
      return {
        ...state,
        partnerSlug: payload,
      }
    case RESET_USER_CONFIG:
      return {
        ...initialState,
      }
    default:
      return state
  }
}
